import { useTagValue } from "@/services/budget/setTags";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { SelectField } from "@/page-components/budgets/components/helper";
import styles from "@/page-components/budgets/components/budgets.module.css";
import closeCross from "@/assets/img/closecross.svg";
import reportStyles from "@/page-components/reporting/reporting.module.css";
import add from "@/assets/img/add.svg";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search-without-apply";
import {
  useDimensionValue,
  useDimensionkey,
} from "@/services/reporting/get-dimension-in-form.repo";
import { useTagsValue } from "@/services/budget/getTags.repo";
import addsymbol from "@/assets/img/addFilterBlue.svg";
import edit from "@/assets/img/budgetEditIcon.svg";
import clsx from "clsx";
import { ReportingContext } from "../reporting-context-file";
import ExportColumns from "./export-column.part";
import { RxReset } from "react-icons/rx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ReportingFilterComponent = ({
  editData,
  setValue,
  service,
  control,
  setTempSelectValues,
  tempSelectValues,
  setExtractData,
  groupByOptions,
  rules,
  disabled,
  clearFilterData,
  resetField,
}) => {
  const [selectedKey, setSelectedKey] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [multiselect, setMultiselect] = useState("");
  const [disableSelectedValues, setDisableSelectedValues] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [showBadgeContainer, setShowBadgeContainer] = useState(false);
  const [selectedTittle, setSelectedTittle] = useState(null);

  const context = useContext(ReportingContext);

  const SelectedTagsLength = Object.keys(context?.selectedTagValues).length;

  useEffect(() => {
    context?.setTempSelectTagValues([]);
  }, [selectedTag]);

  useEffect(() => {
    setTempSelectValues([]);
    context?.setTempSelectTagValues([]);
  }, [context?.selectedCreateGroupBy]);

  useEffect(() => {
    if (editData?.filters) {
      const dimensionValues =
        editData.filters.dimensions?.flatMap((dimension) => dimension.name) ||
        [];
      const tagValues = editData.filters.tags?.flatMap((tag) => tag.name) || [];

      setSelectedDimension(dimensionValues);
      setSelectedTag(tagValues);
    }
  }, [editData]);

  const filterKeys = useMemo(() => {
    return {
      service,
      selectedKey: selectedKey,
      account: service === "azure" ? "subscription" : "account",
      // tags: multiselect,
    };
  }, [service]);

  const dimensionKeyForQuery = useMemo(() => {
    if (service === "gcp") {
      if (selectedKey === "Category") return "category";
      if (selectedKey === "Project") return "project";
    }

    if (service === "azure") {
      if (selectedKey === "Subscription") return "subscription";
    }

    return typeof selectedKey === "string" ? selectedKey.toLowerCase() : "";
  }, [selectedKey, service]);

  const filterKeyTagsValue = useMemo(() => {
    return {
      service,
      // selectedKey: selectedKey,
      selectedKey: dimensionKeyForQuery,
    };
  }, [service, dimensionKeyForQuery]);

  const filterTagKeys = useMemo(() => {
    return {
      service,
      selectedKey: "tags",
    };
  }, [service]);

  const tagKeys = useMemo(() => {
    return {
      service,
      tags: multiselect,
    };
  }, [service, multiselect]);

  // let { data: dimensionTag1, isLoading: dimensionTagLoading } =
  //   useDimensionkey(filterKeys);

  const dimensionTag = [
    {
      name:
        service === "azure"
          ? "Subscription"
          : service === "gcp"
          ? "Project"
          : "Account",
      id:
        service === "azure"
          ? "subscription"
          : service === "gcp"
          ? "project"
          : "account",
    },
    {
      name: service === "gcp" ? "Category" : "Service",
      id: service === "gcp" ? "category" : "service",
    },
    {
      name: "Region",
      id: "region",
    },
  ];

  const validata = [
    "region",
    "service",
    "account",
    "category",
    "project",
    "subscription",
  ];
  let {
    data: dimensionValue,
    isLoading: dimensionValueLoading,
    refetch,
  } = useDimensionValue(
    filterKeyTagsValue,
    validata.includes(dimensionKeyForQuery)
  );

  useEffect(() => {
    if (selectedDimension) {
      context?.setSelectDimensionKeys(selectedDimension);
    }
  }, [selectedDimension]);

  const isAwsAccount =
    service === "aws" && context?.selectDimesnionKeys?.includes("Account");

  const isAzureSubscription =
    service === "azure" &&
    context?.selectDimesnionKeys?.includes("Subscription");

  useEffect(() => {
    if (isAwsAccount) {
      setSelectedKey("account");
      refetch();
    } else if (isAzureSubscription) {
      setSelectedKey("subscription");
      refetch();
    }
  }, [isAwsAccount, isAzureSubscription, refetch]);

  useEffect(() => {
    if ((isAwsAccount || isAzureSubscription) && dimensionValue?.data?.length) {
      context?.setDimensionValueData(dimensionValue.data);
    }
  }, [isAwsAccount, dimensionValue, context, isAzureSubscription]);

  useEffect(() => {
    if (!editData) return;

    const initialSelectedValues = { "Dimension Values": [] };

    (editData?.filters?.dimensions || []).forEach((dimension) => {
      const formattedValues = dimension.values.map((value) => {
       
        if (
          (isAwsAccount || isAzureSubscription) &&
          context?.dimensionValueData?.length
        ) {
          const matched = context.dimensionValueData.find(
            (item) => item.id === value
          );
          return matched
            ? { id: matched.id, name: matched.name } 
            : { id: value, name: value };
        }

        // Non-AWS → just return value
        return { id: value, name: value };
      });

      initialSelectedValues[dimension.name] = formattedValues;
      initialSelectedValues["Dimension Values"].push(...formattedValues);
    });

    context?.setSelectedValues(initialSelectedValues);
  }, [
    editData,
    isAwsAccount,
    isAzureSubscription,
    context?.dimensionValueData,
  ]);

  // let { data: tagsKeysValues, isLoading: tagsKeysValuesLoading } = useTagsValue(
  //   filterTagKeys,
  //   hasSelectedContext
  // );

  // let { data: tagValues, isLoading: tagValuesLoading } = useTagValue(tagKeys);

  const dimension = dimensionTag?.filter((e) => e.id !== "tags").map((e) => e);

  const handleSelectedkeys = (selected) => {
    setSelectedValue(selected);
    setSelectedKey(selected);
    setSelectedDimension(selected);
    if (selected) {
      let newData =
        (dimension || []).find((item) => item.id === selected) || {};
      setSelectedKey(selected);
      setExtractData((prevSelectedNames) => [...prevSelectedNames, newData]);
    }
  };

  const handleValues = (values) => {
    setSelectedTag(values);
    setMultiselect(values);
    setSelectedValue(values);
  };

  const handleBadgeRemoval = useCallback(
    (filterName, badgeIndex) => {
      context?.setSelectedValues((prevValues) => {
        const updatedValues = { ...prevValues };

        const removeValues = updatedValues[filterName] || [];
        if (filterName !== "Tag Values") {
          delete updatedValues[filterName];

          updatedValues["Dimension Values"] = updatedValues[
            "Dimension Values"
          ].filter((dim) => !removeValues.includes(dim.id));
        }

        context?.setSelectedValues(updatedValues);

        return updatedValues;
      });
    },
    [context?.setSelectedValues]
  );

  const handleBadgeRemovalTags = useCallback(
    (filterName) => {
      if (service === "gcp") {
        context?.setSelectedTagValues([]);
        setSelectedTag({});
      } else {
        context?.setSelectedTagValues((prevValues) => {
          const updatedValues = { ...prevValues };
          const removetagValues = updatedValues[filterName] || [];
          if (filterName !== "Dimension Values") {
            delete updatedValues[filterName];

            if (Array.isArray(updatedValues["Tag Values"])) {
              updatedValues["Tag Values"] = updatedValues["Tag Values"].filter(
                (dim) => !removetagValues.some((rm) => rm.id === dim.id)
              );
            }
          }

          return updatedValues;
        });
      }
    },
    [context?.setSelectedTagValues]
  );
  // ------------------------------------------------------------------------------
  // useEffect(() => {
  //   const initialSelectedValues = {
  //     "Dimension Values": [],
  //   };
  //   const initialSelectedTagValues = {
  //     "Tag Values": [],
  //   };

  //   if (editData) {
  //     const groupByRaw = editData.reportDetails?.group_by || "";
  //     const groupByIds = groupByRaw
  //       .split(",")
  //       .map((entry) => entry.split(":")[0].trim())
  //       .filter(Boolean);

  //     context?.setSelectedCreateGroupBy(groupByIds);

  //     (editData?.filters?.dimensions || []).forEach((dimension) => {
  //       const formattedValues = dimension.values.map((value) => ({
  //         id: value,
  //         name: value,
  //       }));

  //       initialSelectedValues[dimension.name] = formattedValues;
  //       initialSelectedValues["Dimension Values"].push(...formattedValues);
  //     });

  //     // Handle tags
  //     (editData?.filters?.tags || []).forEach((tag) => {
  //       const formattedTagValues = tag.values.map((value) => ({
  //         id: value,
  //         name: value,
  //       }));
  //       initialSelectedTagValues[tag.name] = formattedTagValues;
  //       initialSelectedTagValues["Tag Values"].push(...formattedTagValues);
  //     });

  //     context?.setSelectedValues(initialSelectedValues);
  //     context?.setSelectedTagValues(initialSelectedTagValues);
  //   }
  // }, [editData]);

  // useEffect(() => {
  //   if (context?.SelectedAccounts?.length && resetField) {
  //     resetField("Dimension");
  //     resetField("Tags");
  //     clearFilterData();
  //     setSelectedKey("");
  //     setMultiselect("");
  //     setSelectedValue("");
  //   }
  // }, [context?.SelectedAccounts]);

  // -------------------------------------------------------------------------------
  const handleAddFilterClick = () => {
    setShowBadgeContainer(true);
    setValue("Dimension", undefined);
    context?.setSelectedValues((prevValues) => {
      const mergedValues = { ...prevValues };
      Object.keys(tempSelectValues).forEach((key) => {
        if (mergedValues[key]) {
          mergedValues[key] = [
            ...mergedValues[key],
            ...tempSelectValues[key].filter(
              (item) => !mergedValues[key].some((v) => v.id === item.id)
            ),
          ];
        } else {
          mergedValues[key] = [...tempSelectValues[key]];
        }
      });

      return mergedValues;
    });

    setSelectedDimension("");
    setTempSelectValues([]);
    setSelectedValue("");
    setSelectedKey("");
  };

  const handleAddTagsFilter = () => {
    setShowBadgeContainer(true);
    setValue("Tags", undefined);
    context?.setSelectedTagValues((prevValues) => {
      const mergedValues = { ...prevValues };
      Object.keys(context?.tempSelectTagValues).forEach((key) => {
        if (mergedValues[key]) {
          mergedValues[key] = [
            ...mergedValues[key],
            ...context?.tempSelectTagValues[key].filter(
              (item) => !mergedValues[key].some((v) => v.id === item.id)
            ),
          ];
        } else {
          mergedValues[key] = [...context?.tempSelectTagValues[key]];
        }
      });

      return mergedValues;
    });
    context?.setTempSelectTagValues([]);
    setSelectedTag("");
    setMultiselect("");
  };

  const handleEditClick = (filterName) => {
    setValue("Dimension", filterName);
    setValue("Tags", filterName);
    setTempSelectValues({ [filterName]: context?.selectedValues[filterName] });
    setSelectedDimension(filterName);
    setSelectedValue(filterName);
    setSelectedKey(filterName);
  };

  // useEffect(() => {
  //   const hasValues = Object.keys(selectedValues).some((key) => {
  //     return (
  //       Array.isArray(selectedValues[key]) && selectedValues[key].length > 0
  //     );
  //   });
  //   setShowBadgeContainer(hasValues);
  // }, [selectedValues]);

  useEffect(() => {
    const hasAnyFilter =
      Object.keys(context?.selectedValues).length > 0 ||
      Object.keys(context?.selectedTagValues).length > 0;

    setShowBadgeContainer(hasAnyFilter);
  }, [context?.selectedValues, context?.selectedTagValues]);

  const handleGetDimensionValues = (selectedDimension) => {
    setSelectedKey(selectedDimension);
    setMultiselect(selectedDimension);
    // refetch();
  };

  const handleFilterClick = (fieldName) => {
    setSelectedKey(fieldName);
    setMultiselect(fieldName);
    // refetch();
  };

  // const filteredDimension = useMemo(() => {
  //   const listToHide = Object.keys(context?.selectedValues).filter(
  //     (e) => e !== "Dimension Values" && e !== "Tag Values"
  //   );

  //   return (dimension || []).filter((item) => !listToHide.includes(item.id));
  // }, [context?.selectedValues, dimension]);

  const filteredDimension = useMemo(() => {
    if (editData) {
      const selectedNames = Object.keys(context?.selectedValues || {}).filter(
        (key) => key !== "Dimension Values" && key !== "Tag Values"
      );
      return (dimension || []).filter(
        (item) => !selectedNames.includes(item.name)
      );
    }
    const listToHide = Object.keys(context?.selectedValues).filter(
      (e) => e !== "Dimension Values" && e !== "Tag Values"
    );

    return (dimension || []).filter((item) => !listToHide.includes(item.id));
  }, [dimension, context?.selectedValues, editData]);

  // const filteredTags = useMemo(() => {
  //   const listToHide = Object.keys(context?.selectedTagValues).filter(
  //     (e) => e !== "Dimension Values" && e !== "Tag Values"
  //   );

  //   return (tagsKeysValues?.data || []).filter(
  //     (item) => !listToHide.includes(item.name)
  //   );
  // }, [context?.selectedTagValues, tagsKeysValues?.data]);

  // const filteredGroupByOptions = useMemo(() => {
  //   return groupByOptions.filter(
  //     (item) => !context?.selectedCreateGroupBy?.includes(item.id)
  //   );
  // }, [groupByOptions, context?.selectedCreateGroupBy]);

  return (
    <>
      <div className={styles.budgetsFilterSection}>
        <div className={styles.filterDimension}>
          <div>
            <p className={styles.filterHeading}>Filter</p>
            <p className={styles.filterTagLine}>
              Select cost breakdown dimensions to structure your report data.
            </p>
          </div>
          <div>
            <div className={styles.dimension_div} style={{ width: "100%" }}>
              <div className={styles.dimension_name_css}>Group By</div>
              <div className={reportStyles?.removed}>
                <div
                  className={styles.service_dropdown_box}
                  style={{ width: "40%" }}
                >
                  <FilterSearch
                    hideSearch
                    options={groupByOptions}
                    displayValue="name"
                    disabledforValue={!!editData}
                    selectedValues={groupByOptions.filter((item) =>
                      context?.selectedCreateGroupBy?.includes(item.id)
                    )}
                    searchFieldPlaceholder={"Select Group"}
                    onSelect={(selectedItem) => {
                      context?.setSelectedCreateGroupBy(selectedItem.id);
                      setValue("group_by", selectedItem.id);
                    }}
                    toggle={
                      <FilterSearchToggle
                        placeholder={
                          context?.selectedCreateGroupBy?.length
                            ? groupByOptions
                                .filter((item) =>
                                  context.selectedCreateGroupBy.includes(
                                    item.id
                                  )
                                )
                                .map((item) => item.name)
                                .join(", ")
                            : "Select Group"
                        }
                      />
                    }
                  />
                  <div
                    style={{
                      height: "10px",
                      display: "flex",
                      paddingTop: "2px",
                    }}
                  >
                    {rules.group_by && (
                      <span className="budgetsError">
                        {rules.group_by.message}
                      </span>
                    )}
                  </div>
                </div>
                {context?.selectedCreateGroupBy?.length > 0 && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="reset-tooltip">Reset</Tooltip>}
                  >
                    <span
                      onClick={() => {
                        !editData && context?.setSelectedCreateGroupBy("");
                        !editData && setValue("group_by", "");
                      }}
                      style={{
                        cursor: disabled ? "" : "pointer",
                        padding: "0px 0px 0px 6px",
                        // color: !editData ? "" :"#ced4da"
                        opacity: disabled ? 0.5 : 1,
                      }}
                      className={styles.remove_button}
                    >
                      <RxReset
                        style={{
                          width: "16px",
                          height: "16px",
                          marginBottom: "12px",
                        }}
                      />
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            </div>
            {/* --------------------export column code-------------------------------------------------- */}
            <ExportColumns service={service} disabledCheckbox={!!editData} />
            {/* ---------------------------------------------------------------------------------------- */}
          </div>
          <div
            className="charge_select"
            style={{ justifyContent: "flex-start", paddingBottom: "12px" }}
          >
            <SelectField
              control={control}
              title={"Dimension"}
              placeholder={"Select Dimension"}
              fieldName="Dimension"
              rules={rules?.Dimension?.message}
              azureFieldData={filteredDimension}
              commonFieldData={filteredDimension}
              service={service}
              onSelect={handleSelectedkeys}
              disabled={disabled}
              // isLoading={dimensionTagLoading}
              CustomWidth={true}
            />
            <span className={styles.semicolon}>:</span>
            <div style={{ paddingTop: "10px" }}>
              <div className="accountid_box">
                <div
                  id="filterComp"
                  className="input_box_css"
                  style={{ padding: 0, width: "270px" }}
                  onClick={() => handleGetDimensionValues(selectedDimension)}
                >
                  <MultiselectFilter
                    data={dimensionValue?.data}
                    filterName={dimensionValue?.type || selectedDimension}
                    filterType="Dimension Values"
                    selectedValues={tempSelectValues}
                    azureFieldData={(dimension || []).map((item) => item)}
                    setSelectedValues={setTempSelectValues}
                    disableSelectedValues={disableSelectedValues}
                    setDisableSelectedValues={setDisableSelectedValues}
                    selectedVAlue={selectedValue}
                    isLoading={dimensionValueLoading}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.fill_add_symbol}
              onClick={handleAddFilterClick}
            >
              <img
                src={disabled ? add : addsymbol}
                alt="Add"
                style={{ opacity: disabled ? 0.2 : 1 }}
              ></img>{" "}
              <span
                className={styles.add_filter_name}
                style={{ color: !!editData ? "#ced4da" : "" }}
              >
                Add Filter
              </span>
            </div>
          </div>
          {showBadgeContainer && (
            <BadgeContainer
              showEditIcon={true}
              selectedValues={context?.selectedValues}
              handleEditClick={handleEditClick}
              handleBadgeRemoval={handleBadgeRemoval}
              setSelectedValues={context?.setSelectedValues}
              dimensionValue={dimensionValue?.data}
              dimension={dimension}
              title="Dimension"
              selectedVAlue={selectedValue}
              handleFilterClick={handleFilterClick}
              isLoading={dimensionValueLoading}
              disableSelectedValues={disableSelectedValues}
              setDisableSelectedValues={setDisableSelectedValues}
              disabled={disabled}
            />
          )}
        </div>
        {/* <div className={styles.filterDimension}>
          <div className="charge_select">
            <SelectField
              control={control}
              title={"Tags"}
              placeholder={"Select a tag"}
              fieldName="Tags"
              azureFieldData={filteredTags}
              commonFieldData={filteredTags}
              rules={rules?.Tags?.message}
              service={service}
              onSelect={handleValues}
              isLoading={tagsKeysValuesLoading}
              search="search"
              CustomWidth={true}
              disableOption={
                service === "gcp" && SelectedTagsLength >= 2 ? true : false
              }
            />

            <span className={styles.semicolon}>:</span>
            <div style={{ paddingTop: "10px" }}>
              <div className="accountid_box">
                <div
                  id="filterComp"
                  className="input_box_css"
                  style={{ padding: 0, width: "270px" }}
                  onClick={() => handleGetDimensionValues(selectedTag)}
                >
                  <MultiselectFilter
                    service={service}
                    data={tagValues?.data}
                    filterType="Tag Values"
                    filterName={tagValues?.filter || selectedTag}
                    selectedValues={context?.tempSelectTagValues}
                    azureFieldData={(tagsKeysValues?.data || []).map(
                      (item) => item
                    )}
                    setSelectedValues={context?.setTempSelectTagValues}
                    disableSelectedValues={disableSelectedValues}
                    setDisableSelectedValues={setDisableSelectedValues}
                    selectedVAlue={multiselect}
                    isLoading={tagValuesLoading}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.fill_add_symbol}
              onClick={handleAddTagsFilter}
            >
              <img src={addsymbol} alt="Add"></img>{" "}
              <span className={styles.add_filter_name}>Add Tag</span>
            </div>
          </div>

          {showBadgeContainer && (
            <BadgeContainer
              service={service}
              selectedValues={context?.selectedTagValues}
              handleBadgeRemoval={handleBadgeRemovalTags}
              dimension={tagsKeysValues?.data}
              setSelectedValues={context?.setSelectedTagValues}
              title="Tag"
              dimensionValue={tagValues?.data}
              selectedVAlue={multiselect}
              handleFilterClick={handleFilterClick}
              isLoading={tagValuesLoading}
              disableSelectedValues={disableSelectedValues}
              setDisableSelectedValues={setDisableSelectedValues}
            />
          )}
        </div> */}
      </div>
    </>
  );
};

export default ReportingFilterComponent;

const MultiselectFilter = ({
  service,
  isLoading,
  data,
  filterType,
  selectedValues,
  setSelectedValues,
  filterName,
  azureFieldData,
  disableSelectedValues,
  setDisableSelectedValues,
  selectedVAlue,
  disabled,
}) => {
  let Options = (data || []).map((e) => {
    return {
      id: e.id,
      name: e.name,
    };
  });

  const handleSelect = useCallback(
    (selectedList) => {
      const normalizedList = selectedList || [];

      const selectedIds = normalizedList.map((v) => v.id);
      const matchedOptions = Options.filter((option) =>
        selectedIds.includes(option.id)
      );

      const newValues = matchedOptions.map((option) => ({
        id: option.id,
        name: option.name,
      }));

      setSelectedValues((prevValues) => ({
        ...prevValues,
        [filterName]: newValues,
        [filterType]: newValues,
      }));
    },
    [Options, filterName, filterType, setSelectedValues]
  );

  React.useEffect(() => {
    if (disableSelectedValues) {
      setSelectedValues((prevValues) => {
        const updatedValues = { ...prevValues };
        updatedValues[filterName] = { values: [] };
        updatedValues[filterType] = [];
        return updatedValues;
      });
      setDisableSelectedValues(false);
    }
  }, [
    disableSelectedValues,
    filterName,
    filterType,
    setDisableSelectedValues,
    setSelectedValues,
  ]);

  const formattedPlaceholder = useMemo(() => {
    // const filterSelectedValues = selectedValues[filterName] || [];
    const filterSelectedValues =
      filterName && selectedValues?.[filterName]
        ? selectedValues[filterName]
        : [];

    if (filterSelectedValues?.length > 0) {
      const firstValue = filterSelectedValues[0]?.name || "null";
      const additionalCount =
        filterSelectedValues?.length > 1
          ? ` +${filterSelectedValues?.length - 1}`
          : "";
      return `${firstValue}${additionalCount}`;
    }
    return "Select";
  }, [selectedValues, filterName]);

  return (
    <FilterSearch
      disabled={selectedVAlue?.length <= 0 || disabled}
      loading={isLoading}
      multiselect={service !== "gcp" ? true : false}
      options={Options}
      //   selectedValues={selectedValues[filterName] || []}
      selectedValues={
        filterName && selectedValues?.[filterName]
          ? selectedValues[filterName]
          : []
      }
      onSelect={(list) => {
        handleSelect(list);
      }}
      onRemove={(list) => {
        handleSelect(list);
      }}
      displayValue="name"
      placeholder={"select the Dimension"}
      toggle={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              paddingLeft: "4px",
            }}
          >
            {filterName && selectedValues?.[filterName]?.length > 0 ? (
              <span
                className={styles.toggle_value}
                title={formattedPlaceholder.split("+")[0]}
                style={{
                  textOverflow: "ellipsis",
                  textWrap: "nowrap",
                  maxWidth: "180px",
                  overflow: "hidden",
                }}
              >
                {formattedPlaceholder.split("+")[0]}
              </span>
            ) : (
              <span className={styles.placeholderFilter}>Select</span>
            )}

            {filterName && selectedValues?.[filterName]?.length > 1 && (
              <span className={styles.toggle_value}>
                +{selectedValues[filterName]?.length - 1}
              </span>
            )}
          </div>
        </>
      }
    />
  );
};

const BadgeContainer = ({
  service,
  selectedValues,
  handleBadgeRemoval,
  setSelectedValues,
  dimension,
  dimensionValue,
  title,
  handleFilterClick,
  setDisableSelectedValues,
  disableSelectedValues,
  isLoading,
  disabled,
}) => {
  return (
    <>
      {Object.keys(selectedValues)
        .filter((e) => e !== "Dimension Values" && e !== "Tag Values")
        .map((filterName, index) => (
          <>
            {selectedValues[filterName] && (
              <div
                className={styles.filter_dimension}
                style={{ marginBottom: "8px", marginTop: "-8px" }}
              >
                <span className={styles.dimensio_name}>{title}</span>
                <div className={styles.filter_box}>
                  <span
                    className={clsx("input_box_css", styles.filternamed)}
                    style={{ width: "270px" }}
                  >
                    {filterName}
                  </span>

                  <span
                    className={styles.semicolon}
                    style={{ marginTop: "4px" }}
                  >
                    :
                  </span>
                  <span className={styles.badgesValues}>
                    <div
                      id="filterComp"
                      className="input_box_css"
                      style={{ padding: 0, width: "270px" }}
                      onClick={() => handleFilterClick(filterName)}
                    >
                      <MultiselectFilter
                        service={service}
                        data={dimensionValue}
                        filterName={filterName}
                        filterType="Dimension Values"
                        selectedValues={selectedValues}
                        azureFieldData={(dimension || []).map((item) => item)}
                        setSelectedValues={setSelectedValues}
                        selectedVAlue={filterName}
                        isLoading={isLoading}
                        disableSelectedValues={disableSelectedValues}
                        setDisableSelectedValues={setDisableSelectedValues}
                        disabled={disabled}
                      />
                    </div>
                    <span
                      onClick={() => {
                        if (!disabled) {
                          handleBadgeRemoval(filterName, index);
                        }
                      }}
                      style={{
                        cursor: disabled ? "not-allowed" : "pointer",
                        padding: "0px 0px 0px 6px",
                        opacity: disabled ? 0.5 : 1,
                      }}
                      className={styles.remove_button}
                    >
                      Remove
                    </span>
                  </span>
                </div>
              </div>
            )}
          </>
        ))}
    </>
  );
};
